var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as types from './types';
import { getProject } from 'services/clients/api/project';
import { logError } from 'utils/logs';
export function fetchProject(id, t) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var data, project_page, filteredData, link, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch({ type: types.FETCH_PROJECT_REQUEST });
                    if (!(id === null)) return [3 /*break*/, 1];
                    dispatch({ type: types.FETCH_PROJECT_FAILED });
                    return [3 /*break*/, 4];
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getProject(id)];
                case 2:
                    data = (_c.sent()).data;
                    project_page = data.project_page;
                    filteredData = __rest(data, []);
                    if (project_page) {
                        project_page = Object.fromEntries(Object.entries(data.project_page).filter(function (_a) {
                            var value = _a[1];
                            return value;
                        }));
                    }
                    else {
                        project_page = {};
                    }
                    filteredData.project_page = project_page;
                    dispatch({
                        type: types.FETCH_PROJECT_SUCCEEDED,
                        payload: __assign({}, filteredData),
                    });
                    if (data.name) {
                        document.title = "".concat(data.name, " | ").concat(t('page.title'));
                    }
                    if ((_a = data.project_page) === null || _a === void 0 ? void 0 : _a.logo) {
                        link = (document.querySelector("link[rel*='icon']") || document.createElement('link'));
                        link.type = 'image/png';
                        link.href = (_b = data.project_page) === null || _b === void 0 ? void 0 : _b.logo;
                        document.getElementsByTagName('head')[0].appendChild(link);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _c.sent();
                    logError(err_1);
                    dispatch({ type: types.FETCH_PROJECT_FAILED });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
